import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'components-guide';
import Config from 'config'
import Info from 'config/info';

import './NavLogoWeb.scss';

export interface NavLogoWebProps {
    /**
     *  Invert
     */
    invert?: boolean;
    /**
     * Translate prop
     */
    t: any;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
    /**
     * Function called on click button
     */
    onClick?(): any;
}

const getLogo = ({ invert }: any) => {
    return invert ? Info.logos.web.invert : Info.logos.web.default;
};

const NavLogoWeb: React.FC<NavLogoWebProps> = ({
    invert = false,
    t,
    className,
    style = {},
    onClick = () => {},
    ...props
}) => {
    const isMobile = useMediaQuery({ query: '(max-width: 992px)' });
    const [logo, setLogo] = useState('');
    const classNames = classnames(['nav-logo-web', { invert }, className]);

    useEffect(() => {
        setLogo(getLogo({ invert }));
    }, [invert, isMobile]);

    return (
        <Link
            tabIndex={0}
            className={classNames}
            style={style}
            onClick={onClick}
        >
            <img src={Config.themePath + logo} alt="MyInvestor" width="95" />
        </Link>
        
    );
};

export default NavLogoWeb;
